import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import { Button, Skeleton } from 'src/common';
import { useTranslation } from 'react-i18next';
import { useActiveUsersInfo } from 'src/models/admin/Users/hooks';
import { downloadFile } from 'src/helpers/files';

export const ExportUserTool: FC = () => {
  const { t } = useTranslation();
  const { data, loading } = useActiveUsersInfo();

  const activeUsersCount = data?.getAdminUsersInfo.availableUserCount;

  const onExport = useCallback(() => {
    if (!data) return;

    const blob = new Blob([data.getAdminUsersInfo.allUsersCSV], { type: 'text/plain' });
    const href = URL.createObjectURL(blob);

    downloadFile(href, 'all_users.csv');
  }, [data]);

  return (
    <>
      {loading ? (
        <Skeleton />
      ) : (
        <div className={styles.container}>
          <div className={styles.activeUsersCount}>
            <span className={styles.activeUsersCountLabel}>{t('AdminPage.activeUsers')}:</span>
            <span>{activeUsersCount || '—'}</span>
          </div>
          <Button type={'primary'} onClick={onExport} className={styles.button}>
            {t('AdminPage.exportActiveUsers')}
          </Button>
        </div>
      )}
    </>
  );
};

export default ExportUserTool;
